import * as userConst from "../const/users.const";

const initState = {
    lastname: null,
    firstname: null,
    id: null,
    user: null,
    isLogged: false,
    error: null,
    users: null
};

const login = (state = initState, action) => {
    switch (action.type) {
        case userConst.LOGIN_FULFILLED:
            return {
                ...state,
                lastname: action.payload.data.surname,
                firstname: action.payload.data.firstname,
                id: action.payload.data.id,
                isLogged: true,
                user: action.payload.data.email
            };

        case userConst.LOGIN_PENDING:
            return {
                ...state
            };

        case userConst.LOGIN_REJECTED:
            return {
                ...state,
                error: action.payload
            };

        case userConst.GET_ALL_USERS_FULFILLED:
            return {
                ...state,
                users: action.payload.data
            };
        case userConst.GET_ALL_USERS_PENDING:
            return { ...state };
        case userConst.GET_ALL_USERS_REJECTED:
            return { ...state, error: action.payload };

        // LOGOUT

        case userConst.LOGOUT_FULFILLED:
            return initState;

        default:
            return state;
    }
};

export default login;
